// Modules
import xhr from 'modules/xhr';
// API
import { ENDPOINTS } from '../api.config';
// Types
import { TQueryParams, IResMessage } from 'types/appTypes';
import {
  IGetClientLoginsListRes,
  IGetClientLoginDetailsRes,
  ICreateClientLoginRes,
  ICreateClientLoginBody,
  IUpdateClientLoginBodyWithParam,
} from 'types/clientLoginType';

export const getClientLoginsList = (params: TQueryParams) => {
  return xhr.get<IGetClientLoginsListRes, IGetClientLoginsListRes>(
    `${ENDPOINTS.clientLogins}`,
    {
      params,
    },
  );
};

export const getClientLoginDetails = (id: number) => {
  return xhr.get<IGetClientLoginDetailsRes, IGetClientLoginDetailsRes>(
    `${ENDPOINTS.clientLogins}/${id}`,
  );
};

export const createClientLogin = (body: ICreateClientLoginBody) => {
  return xhr.post<ICreateClientLoginRes, ICreateClientLoginRes>(
    `${ENDPOINTS.clientLogins}`,
    body,
  );
};

export const updateClientLogin = ({ id, body }: IUpdateClientLoginBodyWithParam) => {
  return xhr.put<IResMessage, IResMessage>(`${ENDPOINTS.clientLogins}/${id}`, body);
};

export const deleteClientLogin = (id: number) => {
  return xhr.delete<IResMessage, IResMessage>(`${ENDPOINTS.clientLogins}/${id}`);
};
